"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.numberHasValue = void 0;
/**
 * Sprawdzenie czy liczba ma wartość
 *
 * @export
 * @param {number} value
 * @return {boolean}
 */
function numberHasValue(value) {
    return !!value || value === 0;
}
exports.numberHasValue = numberHasValue;
//# sourceMappingURL=numberHasValue.js.map